import styled, { css } from 'styled-components';

const Heading = styled.h2`
	font-weight: ${({ theme }) => theme.bold};
	font-size: 1.25rem;

	@media (min-width: ${({ theme }) => theme.breakpoints.md}) {
		font-size: 1.75rem;
	}

	${({ featured }) =>
		featured &&
		css`
			display: inline-block;
			background-color: ${({ theme }) => theme.primary};
			text-transform: uppercase;
			padding: 0.4rem 0.75rem 0.3rem 0.75rem;
			color: #fff;
		`}
`;

export default Heading;
